import { useTranslation } from 'react-i18next';
import { CloseIcon } from '@utils/icons';
import { LINK_ONLY_FLAGS, type LinkOnlyFlag } from '../hooks/useActivityFilters';
import type { IPageFilters } from '../pageFilters';
import styles from './filterBar.module.css';
import pill from './filterPill.module.css';

export interface ILinkOnlyFilterChipsProps {
  filters: IPageFilters;
  onRemove: (flag: LinkOnlyFlag) => void;
}

/**
 * One removable chip per filter that is on but has no control in the panel
 * (`LINK_ONLY_FLAGS`) — what a link seeded and the saved set then kept. The
 * chip names it and its × lifts it, so the list is never narrowed by a filter
 * the reader can't see or undo short of Clear.
 */
export function LinkOnlyFilterChips({ filters, onRemove }: ILinkOnlyFilterChipsProps) {
  const { t } = useTranslation();
  return LINK_ONLY_FLAGS.filter((flag) => filters[flag]).map((flag) => {
    const label = t(`activities.filter.${flag}`);
    return (
      <span key={flag} className={`${pill.pill} ${pill.pillActive} ${styles.chip}`}>
        {label}
        <button
          type="button"
          className={styles.chipRemove}
          aria-label={t('activities.filter.removeChip', { label })}
          onClick={() => onRemove(flag)}
        >
          <CloseIcon size={12} />
        </button>
      </span>
    );
  });
}
